import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { ValAssetsComponent } from './components/val-assets/val-assets.component';

import { AssetModule } from './modules/assetModule/asset.module';
import { HomeModule } from './modules/homeModule/home.module';
import { UserModule } from './modules/userModule/user.module';
import { ConfigService } from './shared/services/config.service';
import { AdminComponent } from './modules/userModule/components/profile/admin/admin.component';
import { PipeModule } from './shared/pipe/pipe.module';
import { L1Component } from './modules/userModule/components/profile/l1/l1.component';
import { AdministrationComponent } from './modules/userModule/components/profile/administration-page/administration-page.component';
import {HttpInterceptorService} from './shared/httpInterceptor/http-interceptor.service';
import { WizardComponent } from './components/wizard/wizard.component';
import { FeaturesService } from './shared/services/features-service/features.service';
import { TreeModule } from '@odymaui/angular-tree-component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ValAssetsComponent,
    AdminComponent,
    L1Component,
    AdministrationComponent,
    WizardComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AssetModule,
    HomeModule,
    UserModule,
    AppRoutingModule,
    TreeModule,
    HttpClientModule,
    PipeModule,
    ReactiveFormsModule
  ],
  providers: [ConfigService,{provide:HTTP_INTERCEPTORS,useClass:HttpInterceptorService,multi:true}, FeaturesService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
